import React, { useEffect, useState } from 'react';
import { FiWifiOff } from 'react-icons/fi';

const NoInternetPage = ({ internetConnError }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [reloadPage, setReloadPage] = useState(false);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleOnlineStatusChange);

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
    };
  }, []);

  useEffect(() => {
    if (isOnline && reloadPage) {
      window.location.reload();
    }
  }, [isOnline, reloadPage]);

  const handleReload = () => {
    setReloadPage(true);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-b from-blue-400 to-blue-600">
      <div className="max-w-lg w-full bg-white shadow-lg rounded-lg p-8 transform translate-y-10 transition duration-500 ease-in-out">
        <div className="flex items-center justify-center mb-6">
          <FiWifiOff className="text-6xl text-red-500 animate-bounce" />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4 text-center">{internetConnError ? "No Internet Connection " : "Internal Server Error"}</h1>
        <p className="text-lg text-gray-700 mb-8 text-center"> {internetConnError ? "Please check your internet connection and try again." : "There was an error connecting to the network. Please check your internet connection and try again."}</p>

        <button
          onClick={handleReload}
          className="bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-400 transition duration-300 ease-in-out transform hover:scale-105"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default NoInternetPage;
